import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'react-window';

const MenuList = ({ options, children, getValue }) => {
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * 50;

  return (
    <List
      defaultHeight={270}
      rowCount={children.length}
      rowHeight={50}
      rowComponent={({ index, style }) => <div style={style}>{children[index]}</div>}
      rowProps={{ initialOffset }}
    />
  );
};

MenuList.propTypes = {
  options: PropTypes.array,
  children: PropTypes.array,
  getValue: PropTypes.func,
};

export default MenuList;
